import React from 'react';

export default function ReferralIncome() {
  return <div>ReferralIncome</div>;
}
